import type { AvailabilityBlockType, AvailabilityType } from '@/shared/lib/types/availability';
import type { RelyingParty } from '@/shared/lib/types/graphql';
import { create } from 'zustand';

export type CompanyStore = {
  company: RelyingParty | null;
  setCompany: (company: RelyingParty | null) => void;
  isLoadingCompany: boolean;
  setIsLoadingCompany: (loading: boolean) => void;
  availabilities: AvailabilityType[];
  setAvailabilities: (availabilities: AvailabilityType[]) => void;
  availabilityBlocks: AvailabilityBlockType[];
  setAvailabilityBlocks: (blocks: AvailabilityBlockType[]) => void;
};

export const useCompanyStore = create<CompanyStore>(set => ({
  company: null,
  setCompany: company => set({ company }),
  isLoadingCompany: false,
  setIsLoadingCompany: loading => set({ isLoadingCompany: loading }),
  availabilities: [],
  setAvailabilities: availabilities => set({ availabilities }),
  availabilityBlocks: [],
  setAvailabilityBlocks: blocks => set({ availabilityBlocks: blocks })
}));
